import { TodoRowContainer } from "features/TodoOploggSidebar/Todo/TodoStyles";
import { ErrorTextDescriptionElement } from "features/TodoOploggSidebar/Todo/common/ErrorMessage";
import TextInput from "features/TodoOploggSidebar/Todo/common/TextInput";
import { Todo } from "features/TodoOploggSidebar/Todo/todoList/todoElement/TodoElement";
import useForm, {
  UseFormReturnType,
} from "features/TodoOploggSidebar/Todo/todoList/todoElement/useForm";
import { updateExistingTodo } from "features/TodoOploggSidebar/Todo/todoList/todoListApi";
import { LogLevel, log } from "logging/datadogBrowserLogs";
import { ChangeEvent, Dispatch, SetStateAction, useState } from "react";
import {
  ButtonGroup,
  Button,
  Radio,
  RadioGroup,
  VStack,
} from "shared/components/Spor";
import { useUserInfo } from "shared/hooks/useUserInfo";
import { ROLE_TEXTS } from "shared/types/roles";

interface ITodoEdit {
  todo: Todo;
  setSelectedTodoId: Dispatch<SetStateAction<string>>;
  selectedTodoId: string;
}

const TodoEdit = (props: ITodoEdit) => {
  const { setSelectedTodoId, selectedTodoId, todo } = props;
  const [showError, setShowError] = useState(false);

  const { email } = useUserInfo();

  const { inputs, handleInputChange, handleSubmit }: UseFormReturnType =
    useForm(() => {
      updateExistingTodo({
        ...todo,
        createdAt: todo.dateCreated,
        role: inputs.role,
        description: inputs.description,
        alarmTime: null,
        todoId: selectedTodoId,
        username: email,
      })
        .then(() => {
          setSelectedTodoId("");
        })
        .catch((exception: Error) => {
          setShowError(true);
          log(
            LogLevel.error,
            "TodoEdit",
            `Could not perform api call for updating Todo message with exception: ${exception.message} `,
          );
        });
    }, todo);

  const setRole = (value: string) => {
    handleInputChange({
      target: { value, name: "role" },
      type: "radio",
    } as ChangeEvent<HTMLInputElement & HTMLTextAreaElement>);
  };

  const descriptionCurrentLength = (inputs.description || []).length;
  const disableSubmitButton = descriptionCurrentLength <= 0;
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (descriptionCurrentLength > 0 && inputs.role) {
          handleSubmit(e);
        }
      }}
    >
      <TodoRowContainer
        style={{
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        {ErrorTextDescriptionElement(
          showError,
          "Kunne ikke lagre endret melding. Vennligst prøv igjen.",
          {
            gridColumn: "span 2",
          },
        )}

        <TextInput
          title="Rediger melding"
          messageText={inputs.description}
          handleInputChange={handleInputChange}
        />
        <RadioGroup value={inputs.role} name="role">
          <VStack alignItems="start">
            {ROLE_TEXTS.map((role) => (
              <Radio
                key={`${selectedTodoId}-${role.value}`}
                value={role.value}
                onChange={() => setRole(role.value)}
              >
                {role.text}
              </Radio>
            ))}
          </VStack>
        </RadioGroup>

        <ButtonGroup ml="auto" my="6px">
          <Button
            variant="tertiary"
            size="sm"
            onClick={() => {
              setSelectedTodoId("");
            }}
          >
            Avbryt
          </Button>
          <Button
            variant="secondary"
            size="sm"
            type="submit"
            disabled={disableSubmitButton}
          >
            Lagre
          </Button>
        </ButtonGroup>
      </TodoRowContainer>
    </form>
  );
};

export default TodoEdit;
